export const NAME_DOC_WORD = 'doc';
export const NAME_DOC_PDF = 'pdf';
export const NAME_DOC_VIDEO = 'video';
export const NAME_DOC_IMG = 'img';
export const NAME_DOC_PPTX = 'pptx';
export const NAME_DOC_YOUTUBE = 'youtube';
export const NAME_DOC_AUDIO = 'audio';